import React from 'react';
import { useSelector } from 'react-redux';
import Welcome from 'containers/Info/Welcome';
import UserActions from 'containers/UserActions';
import FurnitureInfos from 'containers/FurnitureInfos';
import InteractiveArea from 'containers/InteractiveArea';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectSelectedIdCabinet,
  makeSelectFurniture,
} from 'containers/Configurator/selectors/furniture';
import { RootState } from 'containers/App/types';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import useMedia from 'use-media';
import DimensionInfos from '../DimensionInfos';
import { makeSelectDisplaySchemaDimension } from '../Configurator/selectors/general';
import SaveForLaterLink from '../SaveForLater/SaveForLaterLink';

interface StateProps {
  selectedCabinetId: string | null;
  furniture: Furniture | null;
  displaySchemaDimension: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  selectedCabinetId: makeSelectSelectedIdCabinet(),
  furniture: makeSelectFurniture(),
  displaySchemaDimension: makeSelectDisplaySchemaDimension(),
});

function Info() {
  const { selectedCabinetId, furniture, displaySchemaDimension } = useSelector(
    stateSelector,
  );
  const isMobile = useMedia({ maxWidth: 1023 });

  return (
    <div className="flex flex-col h-full justify-between items-center">
      <div className="">
        <InteractiveArea />
      </div>
      {!isMobile && (
        <div className="flex flex-col">
          {selectedCabinetId === null && <DimensionInfos />}

          <FurnitureInfos />
          <div className="flex">
            <UserActions
              isCabinetInFurniture={
                furniture !== null &&
                furniture.quantity >= 2 &&
                selectedCabinetId !== null
              }
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Info;
